var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaToolbarWidgetIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.115 6.617c-1.034-.82-2.724-.18-2.724 1.257v5.25c0 1.44 1.688 2.078 2.723 1.26a.743.743 0 00.026-.022l3.134-2.718c.409-.3.617-.787.617-1.262 0-.48-.214-.974-.633-1.273L9.115 6.617zM7.89 7.874c0-.025.006-.039.014-.052a.168.168 0 01.07-.053.196.196 0 01.208.023l3.161 2.506a.757.757 0 00.034.025l.001.003c.006.01.012.03.012.056a.131.131 0 01-.012.056l-.001.003a.778.778 0 00-.06.046l-3.143 2.727a.197.197 0 01-.2.017.167.167 0 01-.069-.053.086.086 0 01-.015-.054v-5.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.57 2.25a7.179 7.179 0 00-7.18 7.179v2.142a7.179 7.179 0 007.18 7.179h2.142a7.179 7.179 0 007.179-7.179V9.43a7.179 7.179 0 00-7.179-7.179H8.57zM2.89 9.429A5.679 5.679 0 018.57 3.75h2.142a5.679 5.679 0 015.679 5.679v2.142a5.679 5.679 0 01-5.679 5.679H8.57a5.679 5.679 0 01-5.678-5.679V9.43z"
  })));
}
export default SvgMediaToolbarWidgetIcon;